import { User } from "lucide-react";
import { assetUrl } from "@/lib/api";

export const Speakers = ({ heading, speakers, light, accent, headingFont, bodyFont }) => {
  if (!speakers?.length) return null;
  return (
    <div data-testid="landing-speakers" className="mt-10">
      {heading && (
        <h3 className={`text-xs font-mono uppercase tracking-[0.25em] mb-5`} style={{ color: accent }}>{heading}</h3>
      )}
      <div className="grid sm:grid-cols-2 gap-4">
        {speakers.map((s) => (
          <div key={s.id} data-testid={`landing-speaker-${s.id}`} className={`flex items-center gap-4 rounded-xl p-3 border ${light ? "bg-white/70 border-slate-200" : "bg-white/[0.03] border-white/10"}`}>
            {s.photo_path ? (
              <img src={assetUrl(s.photo_path)} alt={s.name} className="w-14 h-14 rounded-full object-cover shrink-0" style={{ boxShadow: `0 0 0 2px ${accent}` }} />
            ) : (
              <span className="w-14 h-14 rounded-full grid place-items-center shrink-0" style={{ background: `${accent}26`, color: accent }}><User className="w-6 h-6" /></span>
            )}
            <div className="min-w-0">
              <div className={`font-semibold leading-tight ${light ? "text-slate-900" : "text-white"}`} style={{ fontFamily: `"${headingFont}", sans-serif` }}>{s.name}</div>
              {s.title && <div className={`text-xs mt-1 leading-snug ${light ? "text-slate-500" : "text-slate-400"}`} style={{ fontFamily: `"${bodyFont}", sans-serif` }}>{s.title}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const URL_RE = /(https?:\/\/[^\s]+)/g;

export const Footer = ({ text, light }) => {
  if (!text?.trim()) return null;
  return (
    <footer data-testid="landing-footer" className={`relative z-10 border-t ${light ? "border-slate-200 text-slate-500" : "border-white/10 text-slate-500"}`}>
      <div className="max-w-6xl mx-auto px-6 py-6 text-xs leading-relaxed whitespace-pre-line text-center">
        {text.split(URL_RE).map((part, i) =>
          /^https?:\/\//.test(part) ? <a key={i} href={part} target="_blank" rel="noreferrer" className="underline hover:opacity-80">{part}</a> : part
        )}
      </div>
    </footer>
  );
};
